var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEmpty)?_c('div',{staticClass:"no-journey-available-header"},[_c('h1',[_vm._v(_vm._s(_vm.content.JOURNEY_LIST.NO_JOURNEY_AVAILABLE))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }